import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import queryString from 'query-string';

import workspaceActions from '@/actions/workspaceActions';
import LoginPage from '@auth/components/LoginPage';
import SignupPage from '@auth/components/SignupPage';
import { useCurrentUserContext } from '@shared/hooks/useCurrentUserContext';
import { useDispatch } from 'react-redux';
import { APPLICATION_TYPE } from '@shared/constants';
import { useAppNameParameter, useShouldDisplaySignup } from '@shared/hooks';
import { redirectToLLM } from '@shared/utils';

const ClaimInvite = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user: currentUser } = useCurrentUserContext();
  const { workspaceCode = '' } = queryString.parse(window.location.search);
  const isUserLoggedIn = !!currentUser?.loggedIn;
  const username = currentUser?.userName;
  const selectedApp = currentUser?.userAppType;
  const appNameParameter = useAppNameParameter({ parameterName: 'app' });
  const { data: shouldDisplaySignup, isLoading } = useShouldDisplaySignup();

  useEffect(() => {
    if (!isUserLoggedIn || !workspaceCode) return;

    dispatch(workspaceActions.claimWorkspaceInvite(workspaceCode)).then(
      workspaceName => {
        if (selectedApp === APPLICATION_TYPE.llm) {
          redirectToLLM(workspaceName);
        } else {
          history.push(`/${username}/${workspaceName}`);
        }
      }
    );
  }, [dispatch, history, isUserLoggedIn, selectedApp, username, workspaceCode]);

  if (isLoading) {
    return null;
  }

  const PageComponent = shouldDisplaySignup ? SignupPage : LoginPage;

  return (
    <PageComponent
      defaultApp={appNameParameter}
      workspaceCode={workspaceCode}
    />
  );
};

export default ClaimInvite;
